module.exports = __webpack_public_path__ + "img/maduo2.eb75efbd.jpg";